import React from "react";
import {
  CircleAnimation,
  ThinCircle,
  Circle,
  IconCircle,
  Icon,
} from "./styles";

export const EncircledIcon = ({ icon }) => (
  <CircleAnimation>
          <IconCircle >
            <Icon src={icon} />
          </IconCircle>  
  </CircleAnimation>
);
